// extracted by css-extract-rspack-plugin
export default {"card":"card-CXW9HG","inner":"inner-hZpstv","list":"list-Oprp6B","yay":"yay-Lz2SCd"};